export default __webpack_public_path__ + "static/media/birta_group.f7f04eb2.png";